import type { IconData } from '@stacksjs/iconify-core'

export const tg4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGo1QMTd8m\"><path fill-opacity=\".7\" d=\"M0 0h682.7v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGo1QMTd8m)\" transform=\"scale(.9375)\"><path fill=\"#ffe300\" d=\"M0 0h767.6v512H0z\"/><path fill=\"#118600\" d=\"M0 208.1h767.6V311H0zM0 .2h767.6v102.9H0z\"/><path fill=\"#d80000\" d=\"M0 .3h306.5v310.6H0z\"/><path fill=\"#fff\" d=\"M134.4 128.4c0-.8 18.9-53 18.9-53l17 52.2s57.4 1.7 57.4.8s-45.3 34.3-45.3 34.3s21.4 60 20.5 58.2s-49.6-36-49.6-36s-49.7 34.3-48.8 34.3c.8 0 18.8-56.5 18.8-56.5l-44.5-33.4z\"/><path fill=\"#118600\" d=\"M0 409.2h767.6V512H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default tg4x3
